import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import InputText from '../../../component/input/InputText';
import useValidator from '../../../utils/validator/useValidator';
import './ChangeDataPlanogramDialog.scss';

const ChangeDataPlanogramDialog = ({ visible, onHide, onSave, currentName, currentSystemId, currentExternalSystemId }) => {
    const { t } = useTranslation();
    const validator = useValidator();
    const [newName, setNewName] = useState('');
    const [validationAttempted, setValidationAttempted] = useState(false);
    const [newExternalSystemId, setNewExternalSystemId] = useState('');

    useEffect(() => {
        if (visible) {
            setNewName(currentName || '');
            setNewExternalSystemId(currentExternalSystemId || '');
            setValidationAttempted(false);
            validator.hideMessages();
        }
    }, [visible, currentName, currentExternalSystemId]);

    const handleSave = () => {
        setValidationAttempted(true);

        if (!validator.allValid()) {
            validator.showMessages();
            return;
        }

        onSave(newName, newExternalSystemId);
        onHide();
    };

    const handleCancel = () => {
        setNewName(currentName || '');
        setValidationAttempted(false);
        validator.hideMessages();
        onHide();
    };

    return (
        <Dialog
            header={t('planogram.rename.title')}
            visible={visible}
            onHide={handleCancel}
            style={{ width: '400px' }}
            modal
            className="rename-planogram-dialog"
            footer={
                <div className="flex w-full gap-3 justify-content-end">
                    <Button
                        label={t('common.save')}
                        onClick={handleSave}
                        className="w-full p-button-primary"
                    />
                    <Button
                        label={t('common.cancel')}
                        onClick={handleCancel}
                        className="w-full p-button-secondary"
                    />
                </div>
            }
        >
            <div className="flex flex-column gap-3">
                <div className="flex gap-3">
                    <InputText
                        id="systemId"
                        label={t('planogram.create.planogramSystemId')}
                        value={currentSystemId || ''}
                        disabled
                    />
                    <InputText
                        id="externalSystemId"
                        label={t('planogram.create.planogramId')}
                        value={newExternalSystemId}
                        onChange={(e) => setNewExternalSystemId(e.target.value)}
                        placeholder={t('planogram.create.planogramIdPlaceholder')}
                        validations='not_required|max:50'
                    />
                </div>
                <InputText
                    id="newName"
                    label={t('planogram.rename.nameLabel')}
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    placeholder={t('planogram.rename.namePlaceholder')}
                    validator={validator}
                    validations="required"
                />
                {validationAttempted && validator.message('newName', t('planogram.rename.nameLabel'), newName, 'required')}


            </div>
        </Dialog>
    );
};

export default ChangeDataPlanogramDialog;


